import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={14}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.875 3.625C3.875 2.58947 4.71447 1.75 5.75 1.75C6.78553 1.75 7.625 2.58947 7.625 3.625C7.625 4.66053 6.78553 5.5 5.75 5.5C4.71447 5.5 3.875 4.66053 3.875 3.625ZM5.75 0.25C3.88604 0.25 2.375 1.76104 2.375 3.625C2.375 5.48896 3.88604 7 5.75 7C7.61396 7 9.125 5.48896 9.125 3.625C9.125 1.76104 7.61396 0.25 5.75 0.25ZM11 5.125C11 4.71079 11.3358 4.375 11.75 4.375C12.1642 4.375 12.5 4.71079 12.5 5.125C12.5 5.53921 12.1642 5.875 11.75 5.875C11.3358 5.875 11 5.53921 11 5.125ZM11.75 2.875C10.5074 2.875 9.5 3.88236 9.5 5.125C9.5 6.36764 10.5074 7.375 11.75 7.375C12.9926 7.375 14 6.36764 14 5.125C14 3.88236 12.9926 2.875 11.75 2.875ZM0.5 10.75C0.5 9.09315 1.84315 7.75 3.5 7.75H8C9.65685 7.75 11 9.09315 11 10.75V13.75H0.5V10.75ZM3.5 9.25C2.67157 9.25 2 9.92157 2 10.75V12.25H9.5V10.75C9.5 9.92157 8.82843 9.25 8 9.25H3.5ZM15.5 10.75C15.5 9.50736 14.4926 8.5 13.25 8.5H11.75V10H13.25C13.6642 10 14 10.3358 14 10.75V11.5H11.75V13H15.5V10.75Z"
      fill="white"
      fillOpacity={0.85}
    />
  </svg>
);
export default SVGComponent;
